export const trendHeatmapFetchDataKeyReset = (state, payload) => {
  return {
    ...state,
    isDataFetchedTrend: false
  }

}